import { api } from './api';

// Consulta a Mercado Libre (vía backend) el costo de envío gratis estimado para un ítem.
// Requiere itemId + itemPrice. Acepta sellerId o siteId (el backend resuelve el seller por país).
export default async function fetchMeliFreeShipping(
	{
		sellerId,
		siteId,
		itemId,
		itemPrice,
		listingTypeId,
		shippingMode,
		logisticType,
		condition = 'new',
	},
	accessToken
) {
	if (!itemId || !itemPrice || itemPrice <= 0) return null;
	if (!sellerId && !siteId) return null;

	try {
		const res = await api.get('/GetMeliFreeShipping', {
			params: {
				sellerId,
				siteId,
				itemId,
				itemPrice,
				listingTypeId,
				shippingMode,
				logisticType,
				condition,
			},
			headers: {
				Authorization: `Bearer ${accessToken}`,
				accept: '*/*',
			},
		});

		return res?.data ?? null;
	} catch (error) {
		console.error('GetMeliFreeShipping error', error?.response?.data || error?.message || error);
		return null;
	}
}
